export default [
  {
    path: '/real-estate-developments-settings/attributes',
    name: 'AttributesList',
    component: () => import(
      'pages/real-estate-developments-settings/attributes/AttributesList.vue'
    )
  },
  {
    path: '/real-estate-developments-settings/attributes/new',
    name: 'AttributesCreate',
    component: () => import(
      'pages/real-estate-developments-settings/attributes/AttributesForm.vue'
    )
  },
  {
    path: '/real-estate-developments-settings/attributes/:id/edit',
    name: 'AttributesEdit',
    component: () => import(
      'pages/real-estate-developments-settings/attributes/AttributesForm.vue'
    )
  },
  {
    path: '/real-estate-developments-settings/attributes/:id',
    name: 'AttributesSingle',
    component: () => import('pages/real-estate-developments-settings/attributes/AttributesSingle.vue')
  }
]
